// Rental Distribution — a namespace parent (architecture-principles §15). It
// owns no route or chrome of its own; each sub-module publishes its own screen
// and this file aggregates them.
import { distributionRunsRoutes } from './distributionRuns'
import { rentReceiptsRoutes } from './rentReceipts'
import { rentLedgerRoutes } from './rentLedger'
import { investorPayoutsRoutes } from './investorPayouts'

export const rentalDistributionsRoutes = [
  ...distributionRunsRoutes,
  ...rentReceiptsRoutes,
  ...rentLedgerRoutes,
  ...investorPayoutsRoutes,
]

// Shared-endpoint hooks exposed cross-module (architecture-principles §10).
// Consumer: AppSidebar's work-queue badges — how many runs await approval, and
// how many receipts need a person to look at them.
export { useRentalDistributionCountsQuery } from './distributionRuns'
export type { RentalDistributionCounts } from './distributionRuns'
export { useRentReceiptCountsQuery } from './rentReceipts'
export type { RentReceiptCounts } from './rentReceipts'

// Consumer: the offering details Overview — its Rent ledger card and "Rent paid
// out" KPI read the property's ledger position, with the ledger's own status
// words so the same property reads the same on both screens.
export { usePropertyRentLedgerQuery, PROPERTY_RENT_STATUS_LABEL } from './rentLedger'
export type { PropertyRentLedgerDetail } from './rentLedger'
